<template>
  <div class="counter">
    <v-btn class="counter-btn" :class="{ 'counter-btn-small': small }" icon @click="subtractQty()"><span>-</span></v-btn>
    <div class="number-counter">{{ counter }}</div>
    <v-btn class="counter-btn" :class="{ 'counter-btn-small': small }" icon @click="addQty()"><span>+</span></v-btn>
  </div>
</template>
<script>
export default {
  name: 'counter-block',
  props: {
    counter: Number,
    small: { type: Boolean, default: () => false }
  },
  methods: {
    addQty() {
      this.$emit('add');
    },
    subtractQty() {
      this.$emit('subtract');
    }
  }
};
</script>
<style>
.counter {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  padding: 5px 10px;
  align-items: center;
  width: 100%;
}
.counter-btn {
  font-size: 30px;
  font-weight: normal;
  cursor: pointer;
}

.counter-btn-small {
  width: 15px !important;
  height: 15px !important;
}

.counter-btn span{
  font-size: 30px;
  color: rgba(0, 0, 0, 0.38)
}
.number-counter {
  color: black;
  font-size: 18px;
}
</style>
